module.exports = __webpack_public_path__ + "static/media/deepprofile.0cce2c43.jpg";